import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=19616406"
import script from "./Browse.vue?vue&type=script&lang=ts"
export * from "./Browse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19616406')) {
      api.createRecord('19616406', component.options)
    } else {
      api.reload('19616406', component.options)
    }
    module.hot.accept("./Browse.vue?vue&type=template&id=19616406", function () {
      api.rerender('19616406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/browse/Browse.vue"
export default component.exports